// Trésors d'Afrique de l'Ouest, 10 ingrédients bruts (liste officielle NANDA SÁ)
// Photos : Wikipedia Commons, matières premières uniquement, jamais de produits finis.
import { l } from "@/i18n/helpers";

export const TRESORS = [
 {
 slug: "hibiscus",
 name: "Hibiscus",
 latin: "Hibiscus sabdariffa",
 territory: l("Guinée-Bissau", "Guinea-Bissau", "Guinea-Bissau"),
 teaser: l("Le rouge éclatant du bissap.", "The vivid red of bissap.", "O vermelho vibrante do bissap."),
 image:
 "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f8/Roselle_%28Hibiscus_sabdariffa%29_2.jpg/1920px-Roselle_%28Hibiscus_sabdariffa%29_2.jpg",
 story: l(
 "Au on l'appelle bissap. Au Mali, dah. Ses calices écarlates donnent une boisson rafraîchissante, des infusions vibrantes et des desserts pleins de caractère.",
 "In Guinea-Bissau it is called bissap. In Mali, dah. Its scarlet calyces yield a refreshing drink, vibrant infusions and desserts full of character.",
 "No Guinea-Bissau chama-se bissap. No Mali, dah. Os seus cálices escarlates dão uma bebida refrescante, infusões vibrantes e sobremesas com muito carácter."
 ),
 harvest: l(
 "Les fleurs sont cueillies à pleine maturité, soigneusement séparées de leur graine puis séchées à l'ombre pour préserver leur couleur intense.",
 "The flowers are picked at full maturity, carefully separated from the seed and dried in the shade to preserve their intense colour.",
 "As flores são colhidas em plena maturidade, cuidadosamente separadas da semente e secas à sombra para preservar a sua cor intensa."
 ),
 products: ["nanda sá", "cosmetiques"],
 benefits: [
 l("Riche en antioxydants", "Rich in antioxidants", "Rico em antioxidantes"),
 l("Effet régulateur", "Regulating effect", "Efeito regulador"),
 l("Source de vitamine C", "Source of vitamin C", "Fonte de vitamina C"),
 ],
 },
 {
 slug: "baobab",
 name: "Baobab",
 latin: "Adansonia digitata",
 territory: l("Guinée-Bissau · Sahel", "Guinea-Bissau · Sahel", "Guinea-Bissau · Sahel"),
 teaser: l("L'arbre de vie, gardien du Sahel.", "The tree of life, guardian of the Sahel.", "A árvore da vida, guardiã do Sahel."),
 image:
 "/photos/nanda-cosmetiques/ing-baobab-hero.jpg",
 story: l(
 "Surnommé l'arbre de vie, le baobab veille sur les paysages d'Afrique de l'Ouest depuis plus de mille ans. Chacune de ses parties, fruit, feuilles, écorce, nourrit des usages culinaires, médicinaux et cosmétiques transmis depuis des générations.",
 "Known as the tree of life, the baobab has watched over West African landscapes for over a thousand years. Every part, fruit, leaves, bark, feeds culinary, medicinal and cosmetic uses handed down through generations.",
 "Apelidada de árvore da vida, o baobá vigia as paisagens da África Ocidental há mais de mil anos. Cada uma das suas partes, fruto, folhas, casca, alimenta usos culinários, medicinais e cosméticos transmitidos ao longo de gerações."
 ),
 harvest: l(
 "La pulpe de baobab est récoltée à la main entre novembre et mars. Naturellement séchée par le soleil, elle est tamisée par les femmes du village avant d'être conditionnée.",
 "Baobab pulp is hand-harvested between November and March. Naturally sun-dried, it is sifted by the women of the village before packaging.",
 "A polpa de baobá é colhida à mão entre Novembro e Março. Naturalmente seca ao sol, é peneirada pelas mulheres da aldeia antes de ser embalada."
 ),
 products: ["nanda sá", "cosmetiques"],
 benefits: [
 l("Riche en vitamine C", "Rich in vitamin C", "Rico em vitamina C"),
 l("Antioxydant naturel", "Natural antioxidant", "Antioxidante natural"),
 l("Source de fibres", "Source of fibre", "Fonte de fibras"),
 ],
 },
 {
 slug: "moringa",
 name: "Moringa",
 latin: "Moringa oleifera",
 territory: l("Guinée-Bissau", "Guinea-Bissau", "Guinea-Bissau"),
 teaser: l("L'arbre miracle, exceptionnellement nutritif.", "The miracle tree, exceptionally nutritious.", "A árvore milagre, excepcionalmente nutritiva."),
 image:
 "https://upload.wikimedia.org/wikipedia/commons/6/6f/Moringa_oleifera_%285209194104%29.jpg",
 story: l(
 "Surnommé l'arbre miracle, le moringa rassemble dans ses feuilles une densité nutritionnelle remarquable. Présent dans nos infusions et nos soins, il incarne la vitalité ouest-africaine.",
 "Known as the miracle tree, moringa concentrates remarkable nutritional density in its leaves. Present in our infusions and skincare, it embodies West African vitality.",
 "Apelidada de árvore milagre, a moringa reúne nas suas folhas uma densidade nutricional notável. Presente nas nossas infusões e nos nossos cuidados, encarna a vitalidade oeste-africana."
 ),
 harvest: l(
 "Les feuilles sont récoltées à la main toute l'année, séchées à basse température pour conserver leurs nutriments, puis broyées finement.",
 "The leaves are hand-harvested year-round, dried at low temperature to preserve their nutrients, and then finely ground.",
 "As folhas são colhidas à mão ao longo de todo o ano, secas a baixa temperatura para conservar os nutrientes, e depois finamente moídas."
 ),
 products: ["nanda sá", "cosmetiques"],
 benefits: [
 l("Protéines végétales complètes", "Complete plant proteins", "Proteínas vegetais completas"),
 l("Antioxydant", "Antioxidant", "Antioxidante"),
 l("Sources de fer et calcium", "Sources of iron and calcium", "Fontes de ferro e cálcio"),
 ],
 },
 {
 slug: "karite",
 name: "Karité",
 latin: "Vitellaria paradoxa",
 territory: l("Guinée-Bissau · Sahel", "Guinée-Bissau · Sahel", "Guiné-Bissau · Sahel"),
 teaser: l("L'or des femmes d'Afrique.", "The gold of African women.", "O ouro das mulheres de África."),
 image:
 "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d6/The_sisterhood_preparing_shea_butter_in_Korhogo%2C_Ivory_Coast.jpg/1920px-The_sisterhood_preparing_shea_butter_in_Korhogo%2C_Ivory_Coast.jpg",
 story: l(
 "Travaillé depuis des siècles par les coopératives féminines, le beurre de karité est extrait des noix de l'arbre du même nom. Émollient, protecteur, profondément réparateur, un trésor universel.",
 "Worked for centuries by women's cooperatives, shea butter is extracted from the nuts of the shea tree. Emollient, protective, deeply restorative, a universal treasure.",
 "Trabalhada há séculos pelas cooperativas femininas, a manteiga de karité é extraída das nozes da árvore do mesmo nome. Emoliente, protectora, profundamente reparadora, um tesouro universal."
 ),
 harvest: l(
 "Les noix tombent au sol entre juin et septembre. Ramassées une à une, elles sont décortiquées, broyées puis longuement barattées pour révéler un beurre couleur ivoire.",
 "The nuts fall to the ground between June and September. Gathered one by one, they are shelled, ground and churned at length to reveal an ivory-coloured butter.",
 "As nozes caem ao chão entre Junho e Setembro. Recolhidas uma a uma, são descascadas, moídas e batidas longamente para revelar uma manteiga de cor marfim."
 ),
 products: ["cosmetiques"],
 benefits: [
 l("Hydratation profonde", "Deep hydration", "Hidratação profunda"),
 l("Riche en vitamines A, D, E, F", "Rich in vitamins A, D, E, F", "Rico em vitaminas A, D, E, F"),
 l("Cicatrisant", "Healing", "Cicatrizante"),
 ],
 },
 {
 slug: "cacao",
 name: "Cacao",
 latin: "Theobroma cacao",
 territory: l("Afrique de l'Ouest", "West Africa", "África Ocidental"),
 teaser: l("La fève amère devenue trésor.", "The bitter bean turned treasure.", "A fava amarga tornada tesouro."),
 image:
 "https://upload.wikimedia.org/wikipedia/commons/a/aa/Breaking_open_cocoa_pods_in_Ivory_Coast.png",
 story: l(
 "Cultivé dans les forêts humides d'Afrique de l'Ouest, le cacaoyer donne des cabosses charnues renfermant des fèves qui, une fois fermentées et séchées, révèlent des arômes profonds et complexes.",
 "Grown in the humid forests of West Africa, the cocoa tree bears fleshy pods holding beans which, once fermented and dried, reveal deep and complex aromas.",
 "Cultivado nas florestas húmidas da África Ocidental, o cacaueiro dá vagens carnudas com favas que, uma vez fermentadas e secas, revelam aromas profundos e complexos."
 ),
 harvest: l(
 "Les cabosses sont récoltées à maturité, ouvertes à la main, les fèves fermentées quelques jours sous feuilles de bananier, puis séchées lentement au soleil.",
 "The pods are harvested at maturity, opened by hand, the beans fermented for a few days under banana leaves, then slowly sun-dried.",
 "As vagens são colhidas na maturidade, abertas à mão, as favas fermentadas alguns dias sob folhas de bananeira, depois secas lentamente ao sol."
 ),
 products: ["cosmetiques"],
 benefits: [
 l("Riche en antioxydants", "Rich in antioxidants", "Rico em antioxidantes"),
 l("Beurre nourrissant", "Nourishing butter", "Manteiga nutritiva"),
 l("Notes gourmandes", "Gourmand notes", "Notas gulosas"),
 ],
 },
 {
 slug: "miel",
 name: "Miel",
 latin: "Apis mellifera",
 territory: l("Sénégal", "Senegal", "Senegal"),
 teaser: l("L'or doré des forêts du sud.", "The golden treasure of the southern forests.", "O ouro dourado das florestas do sul."),
 image: "/photos/tresor-miel.jpg",
 story: l(
 "Les apiculteurs du Sénégal récoltent un miel rare, parfumé par les fleurs de la forêt humide. Chaque pot raconte un territoire.",
 "The beekeepers of Senegal harvest a rare honey, perfumed by the flowers of the humid forest. Every jar tells a territory.",
 "Os apicultores do Senegal colhem um mel raro, perfumado pelas flores da floresta húmida. Cada frasco conta um território."
 ),
 harvest: l(
 "Récolte traditionnelle en fin de saison sèche, sans chauffage ni filtration excessive, pour préserver les arômes naturels.",
 "Traditional harvest at the end of the dry season, without heating or excessive filtration, to preserve the natural aromas.",
 "Colheita tradicional no final da estação seca, sem aquecimento nem filtração excessiva, para preservar os aromas naturais."
 ),
 products: ["nanda sá", "cosmetiques"],
 benefits: [
 l("Cru et non chauffé", "Raw and unheated", "Cru e não aquecido"),
 l("Profil aromatique riche", "Rich aromatic profile", "Perfil aromático rico"),
 l("Source d'antioxydants", "Source of antioxidants", "Fonte de antioxidantes"),
 ],
 },
 {
 slug: "neem",
 name: "Neem",
 latin: "Azadirachta indica",
 territory: l("Sahel · Guinée-Bissau", "Sahel · Guinée-Bissau", "Sahel · Guiné-Bissau"),
 teaser: l("L'arbre aux mille vertus.", "The tree of a thousand virtues.", "A árvore de mil virtudes."),
 image:
 "https://upload.wikimedia.org/wikipedia/commons/7/74/Neem_leaf_photography.jpg",
 story: l(
 "Le neem est utilisé depuis des millénaires en Afrique et en Asie du Sud. Ses feuilles, son écorce et ses graines composent des soins purifiants reconnus pour leur efficacité.",
 "Neem has been used for millennia across Africa and South Asia. Its leaves, bark and seeds compose purifying treatments recognised for their efficacy.",
 "O neem é utilizado há milénios em África e no Sul da Ásia. As suas folhas, casca e sementes compõem cuidados purificantes reconhecidos pela sua eficácia."
 ),
 harvest: l(
 "Les graines sont récoltées à la fin de la saison sèche. Pressées à froid, elles donnent une huile dorée à l'odeur caractéristique.",
 "The seeds are harvested at the end of the dry season. Cold-pressed, they yield a golden oil with a distinctive scent.",
 "As sementes são colhidas no final da estação seca. Prensadas a frio, dão um óleo dourado de aroma característico."
 ),
 products: ["cosmetiques"],
 benefits: [
 l("Purifiant", "Purifying", "Purificante"),
 l("Apaisant cutané", "Skin-soothing", "Calmante cutâneo"),
 l("Reconnu en pharmacopée traditionnelle", "Recognised in traditional pharmacopoeia", "Reconhecido na farmacopeia tradicional"),
 ],
 },
 {
 slug: "touloucouna",
 name: "Touloucouna",
 latin: "Carapa procera",
 territory: l("Guinée-Bissau", "Guinea-Bissau", "Guiné-Bissau"),
 teaser: l("L'huile sacrée des forêts humides.", "The sacred oil of the humid forests.", "O óleo sagrado das florestas húmidas."),
 image:
 "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0f/Noix_Carapa.jpg/1920px-Noix_Carapa.jpg",
 story: l(
 "Issue d'un arbre des forêts denses, l'huile de touloucouna est précieuse, rare, profondément traditionnelle. Elle protège, répare et adoucit la peau comme les cheveux.",
 "From a tree of the dense forests, touloucouna oil is precious, rare and deeply traditional. It protects, repairs and softens both skin and hair.",
 "Proveniente de uma árvore das florestas densas, o óleo de toulucuna é precioso, raro, profundamente tradicional. Protege, repara e suaviza tanto a pele como o cabelo."
 ),
 harvest: l(
 "Les graines tombent au sol à la saison des pluies. Elles sont décortiquées, broyées et pressées à froid par les artisanes de Guinée-Bissau.",
 "The seeds fall to the ground during the rainy season. They are shelled, ground and cold-pressed by the female artisans of Guinea-Bissau.",
 "As sementes caem ao chão na estação das chuvas. São descascadas, moídas e prensadas a frio pelas artesãs do Guiné-Bissau."
 ),
 products: ["cosmetiques"],
 benefits: [
 l("Nourrissant intense", "Intensely nourishing", "Intensamente nutritivo"),
 l("Réparateur capillaire", "Hair-repairing", "Reparador capilar"),
 l("Anti-âge naturel", "Natural anti-ageing", "Anti-idade natural"),
 ],
 },
 {
 slug: "the-de-gambie",
 name: l("Thé de Gambie", "Gambia Tea", "Chá da Gâmbia"),
 latin: "Lippia multiflora",
 territory: l("Guinée-Bissau · Gambie", "Guinée-Bissau · Gambia", "Guiné-Bissau · Gâmbia"),
 teaser: l("Le parfum vert de la brousse.", "The green scent of the bush.", "O perfume verde do mato."),
 image: null,
 imageNote: l(
 "Photo botanique authentique non disponible. Merci de ne pas illustrer cet ingrédient avec une image d'hibiscus (bissap), les deux plantes n'ayant aucun lien botanique.",
 "Authentic botanical photograph not available. Please do not illustrate this ingredient with an image of hibiscus (bissap), the two plants being botanically unrelated.",
 "Fotografia botânica autêntica não disponível. Não ilustrar este ingrediente com uma imagem de hibisco (bissap), as duas plantas não têm qualquer ligação botânica."
 ),
 story: l(
 "Aux notes mentholées et herbacées, le thé de Gambie infuse des moments de calme. Tradition ouest-africaine ancestrale, il est aujourd'hui redécouvert.",
 "With minty, herbaceous notes, Gambia tea infuses moments of calm. An ancestral West African tradition, now rediscovered.",
 "Com notas mentoladas e herbáceas, o chá da Gâmbia infunde momentos de calma. Tradição oeste-africana ancestral, hoje redescoberta."
 ),
 harvest: l(
 "Récolté en saison sèche, séché à l'ombre puis trié manuellement par les coopératives partenaires.",
 "Harvested in the dry season, shade-dried and manually sorted by partner cooperatives.",
 "Colhido na estação seca, seco à sombra e triado manualmente pelas cooperativas parceiras."
 ),
 products: ["nanda sá"],
 benefits: [
 l("Apaisant", "Soothing", "Calmante"),
 l("Digestif", "Digestive", "Digestivo"),
 l("Sans théine", "Caffeine-free", "Sem teína"),
 ],
 },
 {
 slug: "maad",
 name: "Maad",
 latin: "Saba senegalensis",
 territory: l("Guinée-Bissau", "Guinée-Bissau · Guinea-Bissau", "Guiné-Bissau · Guinea-Bissau"),
 teaser: l("Le fruit vif de la savane.", "The vivid fruit of the savannah.", "O fruto vivo da savana."),
 image:
 "https://upload.wikimedia.org/wikipedia/commons/thumb/6/64/Saba_senegalensis_%28Maad%29_01.jpg/1920px-Saba_senegalensis_%28Maad%29_01.jpg",
 story: l(
 "Fruit sauvage de la savane ouest-africaine, le maad (ou madd) est reconnu pour son goût acidulé caractéristique. On le déguste nature, en jus ou en préparations sucrées-salées.",
 "A wild fruit of the West African savannah, maad (or madd) is known for its distinctive tart taste. Eaten fresh, as juice or in sweet-and-savoury preparations.",
 "Fruto selvagem da savana oeste-africana, o maad (ou madd) é conhecido pelo seu sabor ácido característico. Consome-se ao natural, em sumo ou em preparações doces-salgadas."
 ),
 harvest: l(
 "Récolté à maturité dans les zones boisées de Guinée-Bissau, le maad est cueilli à la main et consommé rapidement pour préserver sa fraîcheur.",
 "Harvested at maturity in the wooded areas of Guinée-Bissau, maad is hand-picked and consumed quickly to preserve its freshness.",
 "Colhido na maturidade nas zonas arborizadas da Guiné-Bissau, o maad é apanhado à mão e consumido rapidamente para preservar a sua frescura."
 ),
 products: ["nanda sá"],
 benefits: [
 l("Riche en vitamine C", "Rich in vitamin C", "Rico em vitamina C"),
 l("Profil acidulé", "Tart profile", "Perfil ácido"),
 l("Fruit sauvage traditionnel", "Traditional wild fruit", "Fruto selvagem tradicional"),
 ],
 },
];

export const getTresor = (slug) => TRESORS.find((t) => t.slug === slug);
